<ng-template #tableHead>
  <div nz-row nzJustify="space-between">
    <div nz-col>
      <span class="font-bold">Unassigned Referrals</span>
    </div>
  </div>
</ng-template>

<nz-card [nzTitle]="tableHead" [nzLoading]="pageLoading">
  <nz-table
    #referralsTable
    [nzData]="data"
    [nzLoading]="tableLoading"
    [nzFrontPagination]="false"
    [nzTotal]="totalRecords"
    [nzPageIndex]="page"
    [nzPageSize]="pageSize"
    [nzPageSizeOptions]="pageSizeOptions"
    (nzPageIndexChange)="nzPageIndexChange($event)"
    (nzPageSizeChange)="nzPageSizeChange($event)"
  >
    <thead>
      <tr>
        <th>Referral Id</th>
        <th>Hero Pillar</th>
        <th>Reason</th>
        <th>Partner</th>
        <th>Created</th>
        <th>Age (hours)</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of data">
        <td>{{ row.referralId }}</td>
        <td>{{ row.heroPillar || '-' }}</td>
        <td>{{ row.reasonText }}</td>
        <td>{{ row.partnerId || '-' }}</td>
        <td>{{ row.createdAt | date: 'medium' }}</td>
        <td>{{ row.ageHours }}</td>
        <td>
          <button
            nz-button
            nzSize="small"
            nzType="primary"
            [disabled]="actionLoading"
            (click)="openAssignModal(row)"
          >
            Assign expert
          </button>
        </td>
      </tr>
    </tbody>
  </nz-table>
</nz-card>

<nz-modal
  [(nzVisible)]="isAssignModalOpen"
  nzTitle="Assign an expert"
  (nzOnCancel)="isAssignModalOpen = false"
  (nzOnOk)="confirmAssign()"
  [nzOkLoading]="actionLoading"
  [nzOkDisabled]="!selectedNewExpertId"
  nzOkText="Assign"
>
  <ng-container *nzModalContent>
    <nz-select
      [(ngModel)]="selectedNewExpertId"
      [nzLoading]="expertOptionsLoading"
      nzPlaceHolder="Select a Goals expert"
      style="width: 100%"
    >
      <nz-option
        *ngFor="let expert of expertOptions"
        [nzValue]="expert.id"
        [nzLabel]="expert.name"
      ></nz-option>
    </nz-select>
  </ng-container>
</nz-modal>
